import axios from "axios";
import { server } from "../server";

export function resolveCartLineProductId(item) {
  const raw = item?._id || item?.productId || item?.id;
  return raw ? String(raw) : null;
}

export async function fetchLiveProductStock(productId) {
  try {
    const { data } = await axios.get(`${server}/product/get-product/${productId}`);
    const product = data?.product;
    if (!product) {
      return { ok: false, stock: 0, name: "Product", message: "Product not found.", product: null };
    }
    const stock = Number(product.stock ?? 0);
    return {
      ok: stock > 0,
      stock,
      name: product.name || "Product",
      message: stock > 0 ? "" : `"${product.name || "This item"}" is sold out.`,
      product,
    };
  } catch (error) {
    return {
      ok: false,
      stock: 0,
      name: "Product",
      message: error?.response?.data?.message || "Unable to verify product availability.",
      product: null,
    };
  }
}

export async function assertCartLinesInStock(cart) {
  const lines = Array.isArray(cart) ? cart : [];
  const results = await Promise.all(
    lines.map(async (item) => {
      const productId = resolveCartLineProductId(item);
      if (!productId) {
        return {
          ok: false,
          message: "A cart item is missing product information. Please remove it and try again.",
        };
      }
      const qty = Number(item?.qty || 1);
      const live = await fetchLiveProductStock(productId);
      if (!live.product) {
        return { ok: false, message: live.message || `${live.name} is no longer available.` };
      }
      if (live.stock < qty) {
        return {
          ok: false,
          message:
            live.stock <= 0
              ? `"${live.name}" is sold out.`
              : `"${live.name}" only has ${live.stock} left in stock (your cart has ${qty}).`,
        };
      }
      return { ok: true };
    })
  );
  const failed = results.find((result) => !result.ok);
  return failed || { ok: true };
}
